// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as SuspensionStatus from "../entity/SuspensionStatus.bs.js";
import * as SuspensionApiModel from "../api-model/SuspensionApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  var model = DeccoUtils$Catalyst.resolveResult(SuspensionApiModel.res_decode(json), "SuspensionInfoEntityMapper.re").suspension_info;
  return {
          suspend_status: SuspensionStatus.fromString(model.suspend_status),
          suspension_history: List.map((function (suspension) {
                  return {
                          expiry_time: suspension.expiry_time,
                          comment: suspension.comment,
                          reason: suspension.reason,
                          status: SuspensionStatus.fromString(suspension.event),
                          administrator: suspension.administrator,
                          event_mode: suspension.event_mode,
                          event_time: suspension.event_time
                        };
                }), model.driver_suspension_history)
        };
}

function executeSuspensionHistory(json) {
  var model = DeccoUtils$Catalyst.resolveResult(SuspensionApiModel.suspension_history_res_decode(json), "SuspensionInfoEntityMapper.re");
  var firstEvent = Belt_List.head(model.data);
  var suspend_status = firstEvent !== undefined ? SuspensionStatus.fromString(firstEvent.event) : /* NotSuspended */1;
  return {
          suspend_status: suspend_status,
          suspension_history: List.map((function (suspension) {
                  return {
                          expiry_time: suspension.expiry_time,
                          comment: suspension.comment,
                          reason: suspension.reason,
                          status: SuspensionStatus.fromString(suspension.event),
                          administrator: suspension.administrator,
                          event_mode: suspension.event_mode,
                          event_time: suspension.event_time
                        };
                }), model.data)
        };
}

export {
  execute ,
  executeSuspensionHistory ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
